import React, { Component, PropTypes } from 'react';
import PinchView from 'common/components/pinch_view';

export default class Zoomer extends Component {
  constructor(props) {
    super(props);
    this.state = { zoom: 0.9, maxScale: 8, scaleLevel: 4 };

    this.zoom = this.zoom.bind(this);
    this.zoomIn = this.zoomIn.bind(this);
    this.zoomOut = this.zoomOut.bind(this);
  }

  zoom(interval) {
    const scaleLevel = this.state.scaleLevel + interval;
    if (scaleLevel < 1 || scaleLevel > this.state.maxScale) {
      return;
    }

    const zoom = scaleLevel * 0.25;
    this.setState({ scaleLevel, zoom });
  }

  zoomIn() {
    this.zoom(1);
  }

  zoomOut() {
    this.zoom(-1);
  }

  render() {
    const { children, imageWidth, imageHeight } = this.props;

    return (<PinchView
      imageSize={{ width: imageWidth, height: imageHeight }}
      zoom={this.state.zoom}
      maxScale={this.state.maxScale}
      onZoomIn={this.zoomIn}
      onZoomOut={this.zoomOut}
    >
      { children }
    </PinchView>);
  }
}

Zoomer.propTypes = {
  children: PropTypes.any,
  imageWidth: PropTypes.number,
  imageHeight: PropTypes.number,
};



// WEBPACK FOOTER //
// ./common/components/zoomer.jsx